import CompanySelect from "../../Company/CompanySelect";
import {Button, FormGroup, Input} from "reactstrap";
import {I18n} from "../../../I18n/components/loan";
import React from "react";
import Datetime from "react-datetime";
import moment from "moment";
import {RETAIL, SUPER_ADMIN, USER} from "../../../helpers/constants";
import SingleSelect from "../../Common/SingleSelect";
import "../loan.css";
import LoanOrderStatusSelect from "./LoanOrderStatusSelect";

const LoanOrdersControls = props => {
    const isRetail = props.authority !== SUPER_ADMIN && props.company.types.includes(RETAIL);
    const isUser = props.authority === USER;

    const filterByCompanies = isRetail
        ? null
        : <CompanySelect
            className="loan-order-search-filter"
            lang={props.lang}
            companyId={props.retailerIdFilter}
            companies={props.companies}
            onCompanyChange={props.onFilterClick('retailerIdFilter')}
        />;

    const filterByStores = isRetail && isUser
        ? null
        : <SingleSelect
            className="loan-order-search-filter"
            lang={props.lang}
            id={props.pointIdFilter}
            valueList={props.stores}
            onChange={props.onFilterClick('pointIdFilter')}
            defaultOptionText={I18n[props.lang].store}
        />;

    const createOrderBtn = isRetail && isUser
        ? <Button
            color="success"
            type="button"
            onClick={props.onCreateOrderClick}
        >
            {I18n[props.lang].createOrder}
        </Button>
        : null;

    return (
        <FormGroup>
            <Input
                className="loan-order-search-filter"
                type="text"
                name="filter"
                id="filter"
                value={props.filter}
                onChange={props.onFilterClick('filter')}
                placeholder={I18n[props.lang].searchPlaceholder}
            />
            {filterByCompanies}
            {filterByStores}
            <LoanOrderStatusSelect
                className="loan-order-search-filter"
                lang={props.lang}
                id={props.statusFilter}
                statuses={props.orderStatuses}
                onChange={props.onFilterClick('statusFilter')}
                defaultOptionText={I18n[props.lang].status}
            />
            <Datetime
                className="loan-order-data-filter"
                locale="en-gb"
                timeFormat={false}
                closeOnSelect={true}
                inputProps={{placeholder: `${I18n[props.lang].dateFrom}`}}
                onChange={props.dateFromTimeChange}
                value={props.dateFrom ? moment(props.dateFrom).format('DD.MM.YYYY') : ''}
            />
            <Datetime
                className="loan-order-data-filter date-to"
                locale="en-gb"
                timeFormat={false}
                closeOnSelect={true}
                inputProps={{placeholder: `${I18n[props.lang].dateTo}`}}
                onChange={props.dateToTimeChange}
                value={props.dateTo ? moment(props.dateTo).format('DD.MM.YYYY') : ''}
            />
            <Button
                className="mr-2"
                color="primary"
                type="button"
                onClick={props.getFiltered}
            >
                {I18n[props.lang].filter}
            </Button>
            <Button
                className="mr-2"
                color="primary"
                type="button"
                onClick={props.clearFilters}
            >
                {I18n[props.lang].resetFilters}
            </Button>
            {createOrderBtn}
        </FormGroup>
    )
}

export default LoanOrdersControls;


// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrdersControls.js